import {ApiHelper} from "../apiHelper";
import {Observable} from "rxjs";
import {BaseDao} from "./BaseDao";
import {ConstantMan} from "../constantMan";

export class AvsDao extends BaseDao {
    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.AVS, apiHelper);
    }

    public create(encoding: IEncodingPayload): Observable<any> {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/encodeSingle';
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(
            url,
            'POST',
            null,
            encoding,
            headers
        );
    }

    public bulkCreate(encodings: { encodings: IEncodingPayload[] }): Observable<IEncodingResponse[]> {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/encodeBulk';
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(
            url,
            'POST',
            null,
            encodings,
            headers
        );
    }

    public editEncoding(encoding: IEditEncodingPayload): Observable<IEncodingResponse> {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/editEncoding/' + encoding.encodingId;
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(
          url,
          'PUT',
          null,
          encoding,
          headers
        );
    }

    public deleteEncoding(encoding: IEditEncodingPayload): Observable<IEncodingResponse> {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/delete/' + encoding.encodingId;
        return this.apiHelper.delete(
          url,
          null,
          null
        );
    }

    public bulkEditEncodings(encodings: IEditEncodingPayload[]): Observable<IEncodingResponse[]> {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/editBulk';
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(
          url,
          'PUT',
          null,
          { encodings: encodings },
          headers
        );
    }

    public emailMetadata(
      encodings: IEncodingPayload[],
      recipients: string[],
      customerName: string,
      formatName: string
      ): Observable<boolean> {

        const body = {
            encodings: encodings,
            recipients: recipients,
            customerName: customerName,
            formatName: formatName
        }
        const url = this.apiHelper.getServiceName() + this.getResource() + '/email-metadata';
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(
          url,
          'POST',
          null,
          body,
          headers
        );
    }

    public emailSharedAgency(
      sharedAgency: string,
      advertiser: string,
      brand: string,
      format: string,
      assetCodes: string[]
    ): Observable<boolean> {

        const body = {
            advertiser: advertiser,
            brand: brand,
            format: format,
            sharedAgency: sharedAgency,
            assetCodes: assetCodes
        }
        const url = this.apiHelper.getServiceName() + this.getResource() + '/email-shared-agency';
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(
          url,
          'POST',
          null,
          body,
          headers
        );
    }

    formatDateForAVS(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
}

export interface IEncodingPayload {
    assetcode: string;
    encoding: IEncoding;
}

export interface IEncoding {
    facility: string;
    customer: string;
    profile: string;
    format: string;
    enddate?: string;
    attributes: any;
}

export interface IEncodingResponse {
    status: string;
    encodingid: number;
    "error-message"?: string;
}

export interface IEditEncodingPayload {
    attributes: Object;
    encodingId: number;
}
